module.exports = __webpack_public_path__ + "8ff209ef22eb8ecc1f69e63a1d75c2ba.pdf";